import { render, staticRenderFns } from "./CubeDetails.component.html?vue&type=template&id=682c4fca&"
import script from "./CubeDetails.component.ts?vue&type=script&lang=ts&"
export * from "./CubeDetails.component.ts?vue&type=script&lang=ts&"
import style0 from "./CubeDetails.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports